/**
 * Returns a number whose value is limited to the given range.
 * @param  {number} value
 * @param  {number} min
 * @param  {number} max
 * @returns {number}
 */
function clampNumberUtil (value, min, max) {
  return Math.min(Math.max(value, min), max)
}

export {
  clampNumberUtil
}
